import { FichaService } from './../ficha-veiculo.service';
import { Component, OnInit } from '@angular/core';
import { finalize, take } from 'rxjs/operators';
@Component({
  selector: 'app-ficha-lista-decisao',
  templateUrl: './ficha-lista-decisao.component.html',
})
export class FichaListaDecisaoComponent implements OnInit {
  public newHome = true;
  public loading = true;

  constructor(private fichaService: FichaService) { }

  ngOnInit() {
    this.fichaService
      .getShowNewHome()
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((value) => (this.newHome = value.newHome), () => this.newHome = true);
  }
}
